module.exports = __webpack_public_path__ + "img/services-shape-1.ced8411f.png";